import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import eventSessionsKeys from 'actions/eventSessions/queryKeys';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import { getPageOffset } from 'utils/pagination';
import { ASSET_READ, ASSET_WRITE, hasPrivilege } from 'utils/privileges';
export var SESSIONS_PER_PAGE = 20;
export var useFetchEventSessions = function useFetchEventSessions(_ref) {
  var eventId = _ref.eventId,
    startDate = _ref.startDate,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? SESSIONS_PER_PAGE : _ref$limit,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page;
  function fetchEventSessions() {
    return _fetchEventSessions.apply(this, arguments);
  }
  function _fetchEventSessions() {
    _fetchEventSessions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offset = getPageOffset({
              page: page,
              itemsPerPage: limit
            });
            return _context.abrupt("return", api('get', "/api/assets/".concat(eventId, "/sessions"), {
              startDate: startDate,
              limit: limit,
              offset: offset
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchEventSessions.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryKey: eventSessionsKeys.eventSessionsList(eventId, startDate, page),
      queryFn: fetchEventSessions,
      placeholderData: keepPreviousData,
      enabled: hasPrivilege(ASSET_READ) || hasPrivilege(ASSET_WRITE)
    }),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    items: (data === null || data === void 0 ? void 0 : data.items) || [],
    total: data === null || data === void 0 ? void 0 : data.total
  });
};
export default useFetchEventSessions;